// Antd needs non-undefined to know that
// a filteredValue is not to be controlled by it
export const CLEANUP_WHEN_EMPTY = null;
